<template>
  <div :class="{ 'handlers': true, 'is-loading': !loaded }">
    <fieldset>
      <legend>{{ title }}</legend>

      <d-alert
        v-if="referenceId === 0"
        theme="light"
        show
        class="text-center">
        You will be able to see and add handlers after saving this {{ itemName }}.
      </d-alert>

      <d-alert
        v-if="loadError"
        theme="warning"
        show
        class="text-center">
        An error occurred during loading handlers.
      </d-alert>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pr-3 mb-3">
        <d-button
          v-if="referenceType === 'AIRPORT'"
          theme="primary"
          @click.prevent="addAirportHandler"
          outline
          class="ml-auto">
          Add new handler
        </d-button>

        <d-button
          theme="success"
          @click.prevent="addHandler"
          outline
          :class="{ 'ml-auto': referenceType !== 'AIRPORT', 'ml-2': referenceType === 'AIRPORT' }">
          <template v-if="referenceType === 'AIRPORT'">Add existing handler</template>
          <template v-else>Add handler</template>
        </d-button>
      </d-row>

      <d-row
        v-if="loaded && !loadError && referenceId !== 0"
        class="pl-3 pr-3">
        <table class="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Phone</th>
              <th>E-mail</th>
              <th>Notes</th>
              <th>Preferred</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <handlers-list-item
              v-for="(handlerData, index) of handlers"
              :key="'handlers-list-item-' + index"
              :referenceId="referenceId"
              :referenceType="referenceType"
              :handlerData="handlerData" />
          </tbody>
        </table>
      </d-row>

      <d-alert
        v-if="loaded && !loadError && referenceId !== 0 && handlers.length === 0"
        theme="light"
        show
        class="text-center">
        There are no handlers for this {{ itemName }}.
      </d-alert>
    </fieldset>
  </div>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';
import HandlersListItem from './HandlersListItem.vue';

export default {
  name: 'handlers-list',
  components: {
    'handlers-list-item': HandlersListItem
  },
  props: {
    title: {
      type: String,
      required: true
    },
    referenceType: {
      type: String,
      required: true
    },
    referenceId: {
      type: Number,
      required: true
    },
    referenceIdKey: {
      type: String,
      required: true
    },
    itemName: {
      type: String,
      required: true
    },
    popupItemType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loaded: false,
      loadError: false,
      handlers: []
    };
  },
  mounted () {
    if (this.referenceId === 0) {
      this.loaded = true;
    } else {
      this.loadHandlers();
    }

    this.$bus.$on('handlers-list-reload', this.reload);
  },
  methods: {
    loadHandlers () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/handlers/items',
        params: {
          pagination: 0,
          where: {
            [this.referenceIdKey]: this.referenceId
          }
        },
        loadedKey: 'loaded',
        outputKey: 'handlers',
        errorKey: 'loadError',
        successAction: () => {
          this.$bus.$emit('handlers-list-loaded');
        }
      });
    },
    addHandler () {
      this.$bus.$emit('show-handler-popup', this.referenceType, this.referenceId, this.popupItemType);
    },
    reload () {
      this.loaded = false;
      this.loadHandlers();
    },
    addAirportHandler () {
      let airportIDs = [this.referenceId];
      let airportsData = this.$root.airports.filter(airport => airportIDs.indexOf(airport.id) > -1);
      this.$bus.$emit('show-airport-handler-popup', airportsData);
    },
    getPreferredHandler () {
      let preferredHandler = this.handlers.filter(handler => handler.is_default);

      if (preferredHandler.length) {
        return {
          name: preferredHandler[0].name,
          email: preferredHandler[0].email,
          phone: preferredHandler[0].phone
        };
      }

      return null;
    }
  },
  beforeDestroy () {
    this.$bus.$off('handlers-list-reload', this.reload);
  }
}
</script>

<style lang="scss" scoped>
.handlers {
  margin: 30px 0;
  position: relative;

  &.is-loading {
    fieldset {
      min-height: 120px;
    }

    &:after {
      background: rgba(255, 255, 255, .66);
      content: "";
      height: 100%;
      left: 0;
      position: absolute;
      top: 0;
      width: 100%;
    }

    &:before {
      content: "Loading data...";
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      z-index: 1;
    }
  }
}
</style>
